import React,{Component} from 'react';
import {ActionSheet} from 'antd-mobile';
import { observer } from 'mobx-react';
import './ListView.less';
// import ProgressState from "../antd/ProgressState";
import {PullRefresh, ProgressState} from 'tplus-components-mobile';
import {tools} from 'tplus-voucher';
import ListsCard from './ListsCard';

@observer
class ListView extends Component{

    constructor(prop){
        super(prop);
    }


    componentDidMount(){
        const {model} = this.props.param;
        model.loadData('fresh');
    }


    onMore=(afterMore)=>{
        const {model} = this.props.param;
        model.loadData('loadMore').then(()=>{
            afterMore&&afterMore(model.lists.length);
        });
    }

    
    onRefresh=(afterRefresh)=>{
        const {model} = this.props.param;
        model.loadData('_fresh').then(()=>{
            afterRefresh&&afterRefresh(model.lists.length);
        });
    }

    moreClick=(rowID)=>{
        const {openChoose} = this.props.param;
        openChoose?this.choose(rowID):this.showActionSheet(rowID);
    }

    itemClick=(rowID)=>{
        const {itemClick} = this.props.param;
        itemClick?itemClick(rowID):''
    }

    choose=(rowID)=>{
        const {itemActionClick,openChoose} = this.props.param;
        itemActionClick(rowID,openChoose);
    }


    showActionSheet=(rowID)=>{
        //弹出选择操作  
        let {onActionSheet,itemActionClick,openChoose} = this.props.param;
        let buttons = itemActionClick(rowID,openChoose);

        // const BUTTONS = ['全部','本人未分享', '本人已分享','取消'];
        ActionSheet.showActionSheetWithOptions({
            options: buttons.map((item)=>{return item.title}),
            cancelButtonIndex: buttons.length-1,
            maskClosable: true,
            'data-seed': 'logId',
        },
        (buttonIndex) => {
            if(buttonIndex == buttons.length - 1) return;
            //更新数据
            onActionSheet(buttons[buttonIndex],rowID);
        });
    }

    

    goDetail=()=>{

    }

    genData = (dataSize) => {
        const {model,openChoose} = this.props.param;
        const dataArr = [];
        for (let i = 0; i < dataSize; i++) {
          const item = model.lists[i];
          dataArr.push(`row - ${i} - open - ${openChoose} - choose - ${item.choose?true:false} - disabled - ${item.disabled}`);
        }
        return dataArr;
      }

    itemRender = (rowData, sectionID, rowID) => {
        const {model,openChoose} = this.props.param;
        const data = model.lists[rowID];
        let iconClass = openChoose?(data.choose?'iconfont iconfangxingxuanzhong rightIcon':'iconfont iconfangxingweixuanzhong rightIcon'):'iconfont icongengduo rightIcon';
        return (
            <ListsCard {...this.props} data = {data} rowID={rowID} moreClick={this.moreClick} itemClick={this.itemClick} />
        )
    }
    
    render(){
        const {model} = this.props.param;
        let length =model.lists?model.lists.length:0;
        return(
            <div className='listView' onClick={this.goDetail}>
            <ProgressState
                state={model.progressState}
                empty={{info:'亲，未查到单据信息哦~'}}
                error={{info:'哎呀, 发生错误了~'}}>
              <PullRefresh
                dataSize={length}
                genData={this.genData}
                useBodyScroll={false}
                onMore={this.onMore}
                onRefresh={this.onRefresh}
                itemRender={this.itemRender}
                footerStyle = {{}}/>
            </ProgressState>
            </div>
        );
    }
}

export default ListView;